// extracted by mini-css-extract-plugin
export default {"container":"ferramentas-b2b_container__3c17J","itemContainer":"ferramentas-b2b_itemContainer__hb7qU","item":"ferramentas-b2b_item__sEf4K"};